import { ISingleIdParams } from '../types/actionParams';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILensActions } from '../types/ILensAction';

export class GetLensActionsRequest extends Request<ISingleIdParams, ILensActions> {
  constructor(id: string) {
    super('getLensActions', { id: id });
  }
}
